// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTimePicker-Container_cls1__Ug-UZ","cls2":"VeloTimePicker-Container_cls2__9zxK7 VeloTimePicker-Container_cls1__Ug-UZ"};